import React from 'react';
import { useNavigate } from 'react-router-dom';

const AutorizacionUsuarios = () => {
    const navigate = useNavigate();

    const handleGoBack = () => {
        navigate(-1);
    };

    return (
        <div className="flex flex-col items-center justify-center min-h-screen p-4 bg-gray-100">
            <div className="w-full max-w-2xl p-8 bg-white rounded-lg shadow-lg">

                <h2 className="text-xl font-bold mb-4 text-[#f79865ff] text-center">
                    Autorización para tratamiento de datos personales de nuevos usuarios
                </h2>
                
                <p className="mb-4 text-gray-700 leading-relaxed">
                    Yo, declaro que, actuando en nombre propio, de manera libre, previa, expresa, voluntaria e informada, autorizo de forma explícita a la <b className="font-semibold">RED COLOMBIANA DE PRESTACIÓN Y CUIDADOS EN SALUD S.A.S.</b>, de ahora en adelante REDPLIKA, identificada con el NIT 901.823.589-6, domiciliada en la Carrera 45 A # 95-37 Oficina 604, Bogotá D.C. (Cundinamarca), con dirección electrónica <a href="mailto:Info@redplika.co" className="text-[#f79865ff] hover:underline">Info@redplika.co</a> y número telefónico +57 322 9280050, para que recolecte, almacene, use, circule, actualice, suprima y, en general, trate mis datos personales suministrados en el marco de mi registro como usuario en su plataforma.
                </p>

                <p className="mb-4 text-gray-700 leading-relaxed">
                    Autorizo el tratamiento de mis datos personales de identificación, contacto, preferencias, historial de uso y cualquier información adicional que haya sido proporcionada voluntariamente en el marco de la interacción con la plataforma REDPLIKA, con las siguientes finalidades:
                </p>

                <ul className="list-disc list-inside mb-4 ml-4 text-gray-700 space-y-2">
                    <li>Gestionar mi acceso a los servicios ofrecidos en la plataforma digital de REDPLIKA.</li>
                    <li>Facilitar la interacción con profesionales de la salud y el acceso a servicios de teleorientación o acompañamiento remoto.</li>
                    <li>Brindar información sobre beneficios, descuentos, campañas, programas y actividades desarrolladas por REDPLIKA o sus aliados estratégicos.</li>
                    <li>Atender solicitudes, inquietudes o necesidades relacionadas con el cuidado de la salud y el bienestar.</li>
                    <li>Realizar análisis de uso, estudios estadísticos y mejoras de servicio, respetando en todo momento la privacidad y confidencialidad de mis datos.</li>
                    <li>Cumplir con obligaciones legales, contractuales y reglamentarias aplicables.</li>
                </ul>

                <p className="mb-4 text-gray-700 leading-relaxed">
                    Declaro haber sido informado(a) de que mis derechos como titular de los datos personales incluyen conocer, actualizar, rectificar y suprimir los datos suministrados, así como revocar esta autorización, mediante solicitud presentada a través del correo electrónico <a href="mailto:Info@redplika.co" className="text-[#f79865ff] hover:underline">Info@redplika.co</a> o en la dirección física antes señalada.
                </p>
                
                <p className="mb-4 text-gray-700 leading-relaxed">
                    He sido informado(a) de que mis datos serán tratados conforme a la Política de Tratamiento de Datos Personales de REDPLIKA, disponible en el sitio web <a href="https://www.redplika.co" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline">www.redplika.co</a>, y bajo estándares de seguridad y confidencialidad exigidos por la Ley 1581 de 2012 y normas complementarias.
                </p>
            </div>
        </div>
    );
};

export default AutorizacionUsuarios;
